import {EntitiesResponseApiModel} from "../models/entities.response-api-model";
import {EntitiesResponseDomainModel} from "../models/entities.response-domain-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CompetitorDomainModel} from "../../common/competitor/models/competitor-domain-model";
import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {PartialGameDomainModel} from "../../partial-game/models/partial-game-domain-model";
import {FullAthleteDomainModel} from "../../full-athlete/models/full-athlete/full-athlete.domain-model";
import type {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import type {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";

export class EntitiesFactory extends BaseFactory {
  createResponse(apiModel: EntitiesResponseApiModel, request: BaseApiRequestParams) {
    const responseApiModel: EntitiesResponseApiModel = new EntitiesResponseApiModel(apiModel, request);

    return responseApiModel;
  }

  createDomainModel(competitions: Array<CompetitionDomainModel>, competitors: Array<CompetitorDomainModel>, games: Array<PartialGameDomainModel>, athletes: Array<FullAthleteDomainModel>, request: BaseApiRequestModel) {
    const domainModel: EntitiesResponseDomainModel = new EntitiesResponseDomainModel(competitions, competitors, games, athletes , request);

    return domainModel;
  }
}

